module.exports = __webpack_public_path__ + "img/SST.6024240f.jpg";